"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.processActionsAndMessage = void 0;
const processConsoleLogMessages_1 = require("../node/processConsoleLogMessages");
const extractErrorTrace_1 = require("./extractErrorTrace");
const processError_1 = require("./processError");
exports.processActionsAndMessage = async ({ actions, message: messageIn, sourceMaps, }) => {
    const [message] = await Promise.all([
        processError_1.processError(Object.assign(Object.assign({}, extractErrorTrace_1.extractErrorTrace(actions)), { message: messageIn, sourceMaps })),
        processConsoleLogMessages_1.processConsoleLogMessages({ actions, sourceMaps }),
    ]);
    return message;
};

//# sourceMappingURL=processActionsAndMessage.js.map
